// extracted by mini-css-extract-plugin
export var measureBox = "_7g-0";